module.exports = __webpack_public_path__ + "static/media/intro-hero-formula1.d5b2e32c.png";